const header = {
  homepage: 'https://github.com/Niraj1412',
  title: 'Niraj.',
}

const about = {
  name: 'Niraj Kumar Mahto',
  role: 'Full Stack Engineer | AI & Web Developer',
  description:
    "I'm passionate about building intelligent, user-focused web products that merge creativity with technology. I love turning complex ideas into seamless digital experiences -- whether it's optimizing performance, crafting intuitive UI, or integrating AI to make tools smarter and faster. Currently, I'm working on ClipSmart AI, an intelligent video platform that lets users instantly search, identify, and extract clips from videos.",
  resume: 'https://drive.google.com/file/d/1osfeMD683lhMytDlV-Zx5v5fkY-iAN1g/view?usp=sharing',
  social: {
    linkedin: 'https://linkedin.com/in/niraj1412',
    github: 'https://github.com/Niraj1412',
  },
}

const projects = [
  {
    name: 'ClipSmart AI',
    description:
      'An AI-powered video platform that allows users to instantly search, identify, and extract clips from videos. Built with a scalable backend using MongoDB and AWS, and integrates advanced text-to-video indexing for seamless content discovery.',
    stack: ['React', 'Node.js', 'MongoDB', 'AWS', 'OpenAI API'],
    sourceCode: 'https://github.com/Niraj1412/AI-Clip',
    livePreview: '',
  },
  {
    name: 'Library Management System',
    description:
      'A full-stack platform with React frontend and Django REST Framework backend for managing books, member accounts, lending, and authentication. Features include auto-generated API docs and admin analytics.',
    stack: ['React', 'Django REST Framework', 'PostgreSQL'],
    sourceCode: 'https://github.com/Niraj1412/Library_management_system-client',
    livePreview: '',
  },
  {
    name: 'Stock Search Web App',
    description:
      'A Python and Streamlit-powered dashboard that visualizes Yahoo! Finance data, enabling users to analyze stock performance with interactive charts and summaries.',
    stack: ['Python', 'Streamlit', 'Yahoo Finance API', 'Plotly'],
    sourceCode: 'https://github.com/Niraj1412/Stock-Search-Web-App',
    livePreview: '',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React',
  'Next.js',
  'Node.js',
  'Express.js',
  'MongoDB',
  'AWS',
  'PostgreSQL',
  'Python',
  'Django',
  'Git',
  'CI/CD',
  'REST API',
  'OpenAI API',
]

const contact = {
  email: '14nirajkumar@gmail.com',
}

export { header, about, projects, skills, contact }
